export const BASE_MAX_DOCUMENT_SIZE = 10000;
export const BASE_MAX_AVATAR_OR_LOGO_SIZE = 5000;
